import utils from './utils';

import style from './components/style';
import onclick from './components/onclick';
import menu from './components/menu';
import slider from './components/slider';
import accordion from './components/accordion';
import map from './components/map';
import animation from './components/animation';
import observer from "./components/observer";
import cursor from "./components/cursor";

function initHiPriorityCommon() {
	style.init();
	cursor.init();
	observer.init();
	animation.init();
}

function initLowPriorityCommon() {
    setTimeout(function() {
        
    }, 1000);
}

function initPage() {
	onclick.init();
	slider.init();
    menu.init();
    accordion.init();
    map.init();
}

// document.addEventListener( 'DOMContentLoaded', function () {
utils.domReady(function () {
	initHiPriorityCommon();
	initPage();
	initLowPriorityCommon();
});
